import { Link } from 'react-router-dom';
import type { Dossier } from '@/mocks/dossiers';
import { dimensions } from '@/mocks/dimensions';
import { formatHeat } from '@/utils/dossiers';
import DimensionTag from '@/components/feature/DimensionTag';

export default function ArticleHeader({ dossier }: { dossier: Dossier }) {
  const dimension = dimensions.find((item) => item.id === dossier.dimension);

  return (
    <header className="w-full border-b border-background-200 bg-background-100">
      <div className="relative h-64 w-full overflow-hidden md:h-[420px]">
        <img
          src={dossier.cover}
          alt={dossier.title}
          title={`${dossier.title} - 爆料看点深度拆解`}
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/35 to-foreground-950/10" />
        <div className="absolute bottom-0 left-0 right-0">
          <div className="mx-auto w-full max-w-[1200px] px-4 pb-8 md:px-8 md:pb-10">
            <DimensionTag id={dossier.dimension} />
            <h1 className="mt-4 max-w-4xl font-heading text-2xl font-bold leading-snug text-background-50 md:text-4xl">
              {dossier.title}
            </h1>
            <div className="mt-5 flex flex-wrap items-center gap-x-5 gap-y-2 font-label text-xs text-background-200">
              <span>{dossier.author}</span>
              <span>{dossier.date}</span>
              <span>{dossier.readTime}</span>
              <span className="inline-flex items-center gap-1 text-accent-300">
                <i className="ri-fire-line" />
                {formatHeat(dossier.heat)} 热度
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="mx-auto w-full max-w-[1200px] px-4 py-8 md:px-8">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div className="lg:col-span-8">
            <p className="font-body text-base leading-relaxed text-foreground-700">{dossier.summary}</p>
          </div>
          <div className="lg:col-span-4">
            {dimension && (
              <div className="rounded-lg border border-background-200 bg-background-50 p-5">
                <p className="font-label text-xs tracking-[0.24em] text-foreground-500">所属维度</p>
                <p className="mt-2 font-heading text-base font-semibold text-foreground-950">{dimension.name}</p>
                <p className="mt-2 font-body text-xs leading-relaxed text-foreground-600">{dimension.desc}</p>
                <Link
                  to={`/dossiers?dimension=${dimension.id}`}
                  className="mt-4 inline-flex items-center gap-1.5 font-label text-xs text-primary-600 hover:text-primary-700"
                >
                  查看同维度档案
                  <i className="ri-arrow-right-line" />
                </Link>
              </div>
            )}
          </div>
        </div>

        <div className="mt-6 flex flex-wrap gap-2">
          {dossier.tags.map((tag) => (
            <span
              key={tag}
              className="whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-3 py-1 font-label text-xs text-foreground-700"
            >
              #{tag}
            </span>
          ))}
        </div>
      </div>
    </header>
  );
}